import { isGoogleMapsUrl, getMapEmbedUrl, isUrl } from "@satyrsmc/shared/lib/maps";
export { isGoogleMapsUrl, getMapEmbedUrl, isUrl };

/**
 * Build a Google Static Maps API URL for a location string.
 * Returns null if no location or API key is provided, or if location is a URL
 * (the Static Maps API requires a plain address or lat/lng, not a Maps URL).
 */
export function getStaticMapUrl(
  location: string | null | undefined,
  apiKey: string | null | undefined,
): string | null {
  if (!location?.trim() || !apiKey?.trim()) return null;
  if (isGoogleMapsUrl(location)) return null;
  const encoded = encodeURIComponent(location.trim());
  return `https://maps.googleapis.com/maps/api/staticmap?center=${encoded}&zoom=14&size=400x200&markers=color:red|${encoded}&key=${apiKey}`;
}

/**
 * Extracts the embed URL from Google Maps iframe HTML.
 * Accepts full iframe tag or a bare embed URL; returns the URL or null.
 */
export function extractEmbedUrlFromHtml(input: string | null | undefined): string | null {
  if (!input?.trim()) return null;
  const s = input.trim();
  const srcMatch = s.match(/src=["']([^"']+)["']/i);
  if (srcMatch?.[1]) return srcMatch[1];
  if (s.startsWith("http") && s.includes("embed")) return s;
  return null;
}
